import { HTMLChakraProps, forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { useActionPreviewStyles } from '../useActionPreviewStyles';

export type ActionPreviewTitleProps = HTMLChakraProps<'p'>;

export const ActionPreviewTitle: React.FC<ActionPreviewTitleProps> = forwardRef<
  ActionPreviewTitleProps,
  'p'
>(({ children, ...props }, ref) => {
  const { title } = useActionPreviewStyles();

  return (
    <chakra.p sx={title} className="action-preview-title" {...props} ref={ref}>
      {children}
    </chakra.p>
  );
});
ActionPreviewTitle.displayName = 'ActionPreviewTitle';
